export const SIZE = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;

export const SKIN = {
  LIGHT: 'light',
  NEUTRAL: 'neutral',
  STANDARD: 'standard',
} as const;
